// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout[data-v-0b008bab]{display:grid;grid-gap:clamp(4rem,8vw,5rem);gap:clamp(4rem,8vw,5rem)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
